<template>
  <div class="pt-vod mb_controller w-100 max-width-player">
    <div class="container-fluid">
      <div
        class="row justify-content-center mb-0 mb-lg-4 mb-xl-5 pt-0 pt-lg-3 pt-xl-4"
      >
        <div class="col-12 px-0">
          <div class="w-100 d-flex" style="max-width: 1190px;margin: 0 auto;">
            <!-- uncomment this later -->
            <!-- <VideoPlayer :id="player_id" :type="'video'" /> -->
            <div class="embed-responsive embed-responsive-16by9">
              <div
                id="vidBox"
                class="player embed-responsive-item"
                ref="vidBox"
              ></div>
              <!-- <iframe
                class="player embed-responsive-item"
                :src="`https://rtm-player.glueapi.io/latest/h/${playerId}`"
                frameborder="0"
                allowfullscreen
                v-if="playerId"
              ></iframe>
              <div class="w-100 h-100" v-else style="background: black;"></div> -->
            </div>
            <!-- uncomment this again if they want to enable again -->
            <!-- <div class="embed-responsive embed-responsive-16by9" v-else>
              <iframe
                class="player embed-responsive-item"
                src="https://player.clevercast.com/?account_id=WmL0bd&amp;event_id=Vry6vX"
                frameborder="0"
                style="border: 0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div> -->
          </div>
        </div>
      </div>
      <div class="row d-none d-md-flex">
        <div
          class="col-12 px-0 mt-3 mt-lg-0"
          style="background-color: #111319;"
        >
          <div class="w-100">
            <div class="tab w-100">
              <div class="tab-wrapper">
                <!-- Tab 1 -->
                <input id="tab1" type="radio" name="tabsA" checked />
                <label class="mb-0" for="tab1">{{ todays_date }}</label>
                <div class="tab-content">
                  <timelineJadual :data="todays_list" v-if="show_todays_epg" />
                  <div class="w-100" v-else>
                    <p class="no-record-title">Tiada rekod dijumpai</p>
                  </div>
                </div>

                <!-- Tab 2 -->
                <input id="tab2" type="radio" name="tabsA" />
                <label class="tab-button mb-0" for="tab2">Esok</label>
                <div class="tab-content">
                  <timelineJadual
                    :data="tomorrows_list"
                    v-if="show_tomorrows_epg"
                  />
                  <div class="w-100" v-else>
                    <p class="no-record-title">Tiada rekod dijumpai</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 d-flex d-md-none">
        <div class="col-12 px-0 mt-3 mt-lg-0" style="background-color: #000;">
          <vodTabsMobile
            :todaysData="todays_list"
            :tomorrowsData="tomorrows_list"
            :todays_date="todays_date"
          />
        </div>
      </div>
      <div class="row mt-3 mt-lg-5">
        <!-- <div class="col-12"> -->
        <!-- ads top -->
        <!-- <billboardBannerTop v-if="desktop"></billboardBannerTop>
          <mrecBannerTop v-if="mobile"></mrecBannerTop> -->
        <!-- <MaintainanceDesktop />
          <MaintainanceMobile /> -->
        <!-- </div> -->
        <div class="col-12 px-3 px-lg-0 d-none d-md-flex">
          <!-- <SaluranTV /> -->
          <div class="w-100 carousel-main-height-wrapper">
            <div
              class="container-fluid px-2 px-md-3 position-relative section-padding"
            >
              <div class="row align-items-center mb-2">
                <div class="col-12 my-4">
                  <tvFastChannelRails />
                </div>
                <div class="col-12 my-4">
                  <tvRails />
                </div>
                <div class="col-12 my-4">
                  <saluranKhas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <!-- ads bottom -->
          <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
          <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import BreadCrumbsHeader from '@/components/common/breadCrumbsHeader.vue';
import VideoPlayer from '@/components/players/videoPlayer.vue';
import social from '../components/popup/sharepopup';
// import billboardBannerTop from "../components/ads/billboardBannerTop";
// import mrecBannerTop from "../components/ads/mrecBannerTop";
import billboardbannerbottom from '../components/ads/live/billboardBannerBottom';
import mrecbannerbottom from '../components/ads/live/mrecBannerBottom';
import tvCard from '../components/cards/v1/tvCard.vue';
import ChevronRight from '../../src/assets/rtmklik/svg/theme_chevron_right.svg';
import ChevronLeft from '../../src/assets/rtmklik/svg/theme_chevron_left.svg';
// maintainance
// import MaintainanceDesktop from "../components/ads/maintainance/leaderboardTop.vue";
// import MaintainanceMobile from "../components/ads/maintainance/mobileMidRec.vue";
// v2
import tvFastChannelRails from '../components/carousel/homepage/v2/tvFastChannelRails.vue';
import tvRails from '../components/carousel/homepage/v2/tvRails.vue';
import saluranKhas from '../components/carousel/homepage/v2/saluranKhas.vue';
import timelineJadual from '../components/common/timelineJadual.vue';
import vodTabsMobile from '../components/common/vodTabsMobile.vue';

import axios from 'axios';
export default {
  data: function() {
    return {
      share: [],
      playerId: '',
      id: '',
      initialization: false,
      active_obj: [],
      title: '',
      small_icon: '',
      channel_title: '',
      mobile: false,
      desktop: false,
      exclude_id: 3902,
      todays_list: [],
      tomorrows_list: [],
      todays_date: '',
      tomorrows_date: '',
      show_todays_epg: false,
      show_tomorrows_epg: false,
      tv_list: [],
    };
  },
  components: {
    social,
    VideoPlayer,
    BreadCrumbsHeader,
    tvCard,
    // billboardBannerTop,
    // mrecBannerTop,
    billboardbannerbottom,
    mrecbannerbottom,
    // MaintainanceDesktop,
    // MaintainanceMobile,
    tvFastChannelRails,
    tvRails,
    saluranKhas,
    timelineJadual,
    vodTabsMobile,
  },
  created: function() {
    this.$store.dispatch('fetchRTMTVList', { self: this });
  },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    itemClick(item) {
      this.$router.push('/live/' + item.id);
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    initializecontentview() {
      var self = this;
      var token = localStorage.getItem('token');
      $.ajax({
        type: 'POST',
        url: 'https://rtm.glueapi.io/report/viewed',
        contentType: 'application/json; charset=utf-8',
        headers: {
          'X-AUTH-TOKEN': `${token}`,
        },
        data: JSON.stringify({
          idContent: self.playerId, // Content ID from content api response
          contentTitle: self.channel_title,
          site: 'RTMKlik',
          dbLogging: 1,
        }),
        dataType: 'json',
        success: function(data) {
          //   console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: 'POST',
        url: 'https://rtm.glueapi.io/report/page-view',
        contentType: 'application/json',
        data: JSON.stringify({
          href: self.$route.path,
          title: self.channel_title,
          referrer: 'Direct',
          site: 'RTMKlik',
        }),
        dataType: 'json',
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },

    async getEPGList(id, date, type) {
      let timezone = this.getTimeZone();
      let tv_id;
      if (id == 1) {
        tv_id = 1;
      } else if (id == 2) {
        tv_id = 2;
      } else if (id == 3) {
        tv_id = 3;
      } else if (id == 4) {
        tv_id = 4;
      } else if (id == 5) {
        tv_id = 7;
      } else if (id == 6) {
        tv_id = 8;
      } else if (id == 7) {
        tv_id = 9;
      } else if (id == 8) {
        tv_id = 10;
      } else if (id == 13669) {
        tv_id = 57;
      } else if (id == 11) {
        tv_id = 57;
      } else if (id == 12) {
        tv_id = 56;
      } else if (id == 13) {
        tv_id = 58;
      } else if (id == 14) {
        tv_id = 59;
      } else if (id == 15) {
        tv_id = 60;
      } else if (id == 16) {
        tv_id = 61;
      } else {
        tv_id = id;
      }

      try {
        axios
          .get(
            `https://rtm.glueapi.io/v3/epg/${tv_id}/ChannelSchedule?dateStart=${date}&dateEnd=${date}&timezone=${timezone}&embed=author,program`
          )
          .then((response) => {
            // this.assignDetailsWithoutEps(response.data);
            if (type == 'today') {
              this.assignTodaysEPG(response.data);
            } else if (type == 'tomorrow') {
              this.assignTomorrowEPG(response.data);
            }
            return response.data;
          });
      } catch (e) {
        console.log(e);
      }
    },
    assignTodaysEPG(obj) {
      const convertedData = obj.schedule;
      const nowDate = Date.now();
      const store = [];
      convertedData.forEach((element, idx) => {
        const formattedDateTimeEnd = this.convertTimestamp(element.dateTimeEnd);
        if (this.convertTimestamp(element.dateTimeEnd) > nowDate) {
          store.push(element);
        }
      });

      this.todays_list = store;

      if (this.todays_list.length > 0) {
        this.show_todays_epg = true;
      }
    },
    assignTomorrowEPG(obj) {
      this.tomorrows_list = obj.schedule;
      if (this.tomorrows_list.length > 0) {
        this.show_tomorrows_epg = true;
      }
    },
    async init() {
      if (this.$route.params.id) {
        const response = await axios.get(
          `https://rtm.glueapi.io/v3/content?idSchemas=2001,2012,2018&fields=title,slug&limit=30`
        );

        const listData = response.data.data;

        listData.forEach((element) => {
          if (
            this.lowerCaseAndRemoveSpace(element.longTitle) ===
            this.$route.params.id
          ) {
            this.id = element.id;
            this.playerId = element.id;
          }
        });

        // todays date
        let todayDate = this.getTodaysDate('today');
        let tomorrowDate = this.getTodaysDate('tomorrow');

        this.todays_date = todayDate;
        this.getEPGList(this.id, todayDate, 'today');
        this.getEPGList(this.id, tomorrowDate, 'tomorrow');

        this.initializepageview();
        this.initializecontentview();
        this.playerInit(this.id);
      } else {
        this.$router.push('/live/tv1');
      }
    },
    playerInit(id) {
      var target = document.getElementById('vidBox');
      this.initializeTVPlayerWithAds(id, target, 'live');
    },
  },
  mounted() {
    this.deviceCheck();
  },
  beforeMount() {
    this.init();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    $('#vidBox').empty();
    // peer5.destroy();
  },
};
</script>

<style scoped>
.mb_controller {
  margin-bottom: 40px;
}
.pt-vod {
  padding: 0;
  min-height: 80vh;
  overflow: hidden;
}
.min-height-for-section {
  /* min-height: 100vh; */
  padding-bottom: 80px;
}
.cursor-pointer {
  cursor: pointer;
}
.set-overflow {
  overflow-y: hidden;
}
.pt-livetv {
  padding-top: 90px;
}
.jadual-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 18px;
  font-weight: bold;
  line-height: 1.28;
  text-align: left;
  color: #fff;
}
.next-day-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 16px;
  font-weight: bold;
  line-height: 1.19;
  text-align: left;
  color: #dae12f;
  padding-top: 2px;
}

.epg-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 12px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.epg-desc {
  font-family: 'HelveticaNeue-Bold';
  font-size: 12px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: rgb(137, 136, 136);
}
.no-record-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}

.episode-box {
  width: 44px;
  height: 44px;
  padding: 12px;
  border-radius: 3px;
  background-color: #23252b;
}
.episode-box.active {
  background-color: #d2d92e;
}
.episode-box.active span {
  color: #000000;
}
.episode-box span {
  font-family: 'HelveticaNeue-Bold';
  font-size: 18px;
  font-weight: bold;
  line-height: 1.28;
  text-align: center;
  color: #fff;
}

.top-10-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 24px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.top-1-wrapper {
  padding: 20px;
  background-color: #1d1f25;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.order-text {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: 'HelveticaNeue-Bold';
  font-size: 14px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #dae12f;
  margin-right: 4px;
}
.order-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.item_img {
  width: 140px;
  height: 188px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}
.item_img img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}

.tabs-setting {
  position: absolute;
}

@media only screen and (max-width: 992px) {
  .set-overflow {
    height: auto;
  }

  .min-height-for-section {
    padding-bottom: 40px;
  }
  .list-div {
    max-width: 480px;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 768px) {
}

@media screen and (max-width: 600px) {
  .pt-vod {
    padding: 0;
  }
}
@media only screen and (max-width: 480px) {
}

/* tabs */
.tab {
  --tab-padding: 16px;
  --tab-bg: #000;
  --tab-active-bg: #171f26;
}
.tab input {
  display: none;
}
.tab input:checked + label {
  background-color: var(--tab-active-bg);
  background-color: var(--tab-active-bg);
  border-radius: 8px 8px 0px 0px;
  color: #d9e021;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.tab input:not(:checked) + label + * {
  display: none;
}
.tab label {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;
  padding: var(--tab-padding);
}
@media (max-width: 575px) {
  .tab label {
    width: 100%;
  }
}
.tab-wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  background-color: var(--tab-bg);
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.tab-content {
  width: 100%;
  padding: var(--tab-padding);
  background-color: var(--tab-active-bg);
}
@media (min-width: 576px) {
  .tab-content {
    order: 9999;
  }
}
</style>
